import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError, UserFriendlyError } from "../../../../common/utils/base_error";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";
import { EntradaProdutoForm, EntradaProdutoSchema } from "../schemas/Entrada_Produtos/entrada_produtos";
import { EntradaProduto } from "../../domain/models/entrada_produtos_lista";
import { initialFiltersValues, useEntradaProdutoFilters } from "../hooks/entrada_produto/filter";
import { useEntradaProdutoPagination } from "../hooks/entrada_produto/pagination";
import { CentroCustoDropDown } from "../../../../common/domain/models/centro_custo_dropdown";
import { useDropDownLoader } from "../../../../common/hooks/use_dropdown_loader";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { GridRowId } from "@mui/x-data-grid";
import { FornecedorDropDown } from "../../../../common/domain/models/fornecedor_dropdown";
import { useUserAuthStore } from "../../../../stores/global/userAuth";
import { useProdutoServicoDrawer } from "../../../../common/components/drawers_api/drawers/produto_servico_drawer";
import { ProdutoServicoDropDown } from "../../../../common/domain/models/produto_servico_dropdown";
import { useFornecedorDrawer } from "../../../../common/components/drawers_api/drawers/fornecedor_drawer";
import { OrdemCompraDropDown } from "../../../../common/domain/models/ordem_compra_dropdown";
import { loadEntradaProdutosSessao } from "../utils/load_entrada_produtos_sessao";

type LoadEstoqueListaFuncState = {
  IdEntradaProduto?: number;
  page?: number;
  rowsPerPage?: number;
  FornecedorPesquisa?: number,
  ProdutoPesquisa?: number,
  pesquisa?: string | null,
  ordemCompra?: number[],
  centroDeCusto?: number[],
  centroDeCustoLista?: CentroCustoDropDown[] | undefined,
  dataEntradaDe?: Date | null,
  dataEntradaAte?: Date | null,
};
export const useEntradaProdutosListaViewModel = () => {
  const {
    commons: { getAllLogAlteracaoUseCase, getAllLogAlteracaoByParentUseCase, getFornecedorDropDownUseCase, getProdutoServicoDropDownUseCase },
    reports: { getReportEntradaProdutoUseCase },
    controleEstoque: { getAllListagemEstoqueUseCase, deleteEntradaPUseCase, updateEntradaPUseCase, createEntradaPUseCase, createEntradaMultiPUseCase, updateEntradaMultiPUseCase },
    compras: {
      createServicoProdutoUseCase,
      createFornecedorUseCase,
      getAllFornecedorQualificacaoUseCase,
    }
  } = useDependencyInjection();

  const { idUsuario } = useUserAuthStore();

  const {
    loadCentroCustoDropDown,
    loadProdutoServicosDropDown,
    loadOrdemComprasDropDown,
  } = useDropDownLoader();

  const hookForm = useForm<EntradaProdutoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(EntradaProdutoSchema),
    defaultValues: {

    }
  });
  //#region Relatorio
  const [openReportModal, setOpenReportModal] = useState(false);
  const [reportViewerState, startReportViewerProcess] = useReportViewer();
  const [produtoServicoDrawerState, startProdutoServicoDrawer] = useProdutoServicoDrawer();
  const [fornecedorDrawerState, startFornecedorDrawer] = useFornecedorDrawer();

  //#endregion
  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) => pushErrorNotification("Erro", [e]),
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [entradaModal, setEntradaModal] = useState<boolean>(false);
  const [entradaMultiModal, setEntradaMultiModal] = useState<boolean>(false);
  const [importXmlModal, setImportXmlModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [entradaProdutoLista, setEntradaProdutoLista] = useState<EntradaProduto[]>([]);
  const [produtoIdSessaoLista, setProdutoIdSessaoLista] = useState<EntradaProduto[]>([]);
  const [centroDeCustoLista, setCentroDeCustoLista] = useState<CentroCustoDropDown[]>([])
  const [fornecedorLista, setFornecedorLista] = useState<FornecedorDropDown[]>([])
  const [ordemComprasDropdown, setOrdemComprasDropdown] = useState<OrdemCompraDropDown[]>([]);
  const [selectedEntradaProduto, setSelectedEntradaProduto] = useState<EntradaProduto | undefined>(undefined);
  const [idEntradaProduto, setIdEntradaProduto] = useState<number | undefined>(undefined);
  const [listaItens, setListaItens] = useState<EntradaProdutoForm[]>([]);
  const [selectedProdutosServicosQuery, setSelectedProdutosServicosQuery] = useState<ProdutoServicoDropDown[] | null>(null);
  const [selectedReportProdutosServicosQuery, setSelectedReportProdutosServicosQuery] = useState<ProdutoServicoDropDown[] | null>(null);
  const [selectedFornecedorQuery, setSelectedFornecedorQuery] = useState<FornecedorDropDown[] | null>(null);
  const [selectedCentroCustoQuery, setSelectedCentroCustoQuery] = useState<CentroCustoDropDown[] | null>(null);
  const [produtoServicoDropdown, setProdutoServicoDropdown] = useState<ProdutoServicoDropDown[]>();

  const { pushErrorNotification, setPageSaving, pushInfoNotification, pushWarnNotification } = usePageLoader();
  const debouncedRef = useCreateDebounceHandler(750);

  const filters = useEntradaProdutoFilters();
  const pagination = useEntradaProdutoPagination();

  // #region Funções de carregamento

  const loadEstoqueListaState = useCallback(async (funcState?: LoadEstoqueListaFuncState) => {
    try {
      const filterID_EntradaProduto = evaluateParamValue(funcState?.IdEntradaProduto, filters.IdEntradaProduto);
      const filteredFornecedorPesquisa = funcState?.FornecedorPesquisa ?? filters.FornecedorPesquisa;
      const filteredProdutoPesquisa = funcState?.ProdutoPesquisa ?? filters.ProdutoPesquisa;
      const filteredCentroDeCusto = funcState?.centroDeCusto ?? filters.centroDeCusto;
      const filteredDataEntradaAte = funcState?.dataEntradaAte ?? filters.dataEntradaAte;
      const filteredDataEntradaDe = funcState?.dataEntradaDe ?? filters.dataEntradaDe;
      const filteredPesquisa = funcState?.pesquisa ?? filters.pesquisa;
      const filteredOrdemCompra = funcState?.ordemCompra ?? filters.ordemCompra;
      const filteredPage = funcState?.page ?? pagination.page;
      const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;

      await getAllListagemEstoqueUseCase.getAllListagemEstoque({
        IdEntradaProduto: filterID_EntradaProduto,
        centroDeCusto: filteredCentroDeCusto,
        ordemCompra: filteredOrdemCompra,
        pesquisa: String(filteredPesquisa),
        dataEntradaAte: filteredDataEntradaAte,
        dataEntradaDe: filteredDataEntradaDe,
        FornecedorPesquisa: filteredFornecedorPesquisa,
        ProdutoPesquisa: filteredProdutoPesquisa,
        IdSessaoMultipla: null
      },
        filteredPage,
        filteredRowsPerPage
      );
      setEntradaProdutoLista(getAllListagemEstoqueUseCase.items);
      pagination.setRowsPerPage(getAllListagemEstoqueUseCase.pageSize);
      pagination.setTotalItems(getAllListagemEstoqueUseCase.totalItems);
    } catch (e: unknown) {
      throw new Error("Falha ao buscar entradas produtos!");
    }
  }, [filters.FornecedorPesquisa, filters.IdEntradaProduto, filters.ProdutoPesquisa, filters.centroDeCusto, filters.dataEntradaAte, filters.dataEntradaDe, filters.pesquisa, filters.ordemCompra, getAllListagemEstoqueUseCase, pagination]);

  const loadFornecedorDropdown = useCallback(async (id?: number) => {
    try {
      const results = await getFornecedorDropDownUseCase.getFornecedorDropDown();
      setFornecedorLista(results);
    } catch (e: unknown) {
      setFornecedorLista([]);
      throw new Error('Falha ao buscar fornecedores!');
    }
  }, [getFornecedorDropDownUseCase]);


  //#endregion

  // #region useEffect
  usePageStartBootstrap(async () => {
    try {
      const jobs = [];

      await loadCentroCustoDropDown(list => setCentroDeCustoLista(list));
      await loadProdutoServicosDropDown(dt => setProdutoServicoDropdown(dt), { incluirCodigoDescricao: true });

      jobs.push(loadEstoqueListaState());
      jobs.push(loadOrdemComprasDropDown(dt => setOrdemComprasDropdown(dt.map(x => ({ idOrdemCompra: x.id, descricao: x.title })))));
      jobs.push(loadCentroCustoDropDown(list => useEntradaProdutoFilters.setState({ centroDeCustoLista: list })));
      jobs.push(loadCentroCustoDropDown(list => setCentroDeCustoLista(list)));
      jobs.push(loadFornecedorDropdown());

      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, 'Falha ao buscar dados da pagina!')[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);

      await loadCentroCustoDropDown(list => setCentroDeCustoLista(list));
      await loadProdutoServicosDropDown(dt => setProdutoServicoDropdown(dt), { incluirCodigoDescricao: true });

      jobs.push(loadEstoqueListaState());
      jobs.push(loadOrdemComprasDropDown(dt => setOrdemComprasDropdown(dt.map(x => ({ idOrdemCompra: x.id, descricao: x.title })))));
      jobs.push(loadCentroCustoDropDown(list => useEntradaProdutoFilters.setState({ centroDeCustoLista: list })));
      jobs.push(loadCentroCustoDropDown(list => setCentroDeCustoLista(list)));
      jobs.push(loadFornecedorDropdown());

      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [
    loadProdutoServicosDropDown,
    loadCentroCustoDropDown,
    loadOrdemComprasDropDown,
    loadEstoqueListaState,
    loadFornecedorDropdown,
    pushErrorNotification,
  ]);
  //#endregion

  // #region Eventos
  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);
      await loadEstoqueListaState({ page: page + 1, });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadEstoqueListaState, pagination, pushErrorNotification]);


  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
      setLoading(true);
      pagination.setPage(1);
      pagination.setRowsPerPage(rowsPerPage);

      await loadEstoqueListaState({ page: 1, rowsPerPage });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadEstoqueListaState, pagination, pushErrorNotification]);


  const handleCadastroEntradaOpenState = useCallback((id: number | null, entradaModal: boolean) => {
    setSelectedProdutosServicosQuery(null);
    if (id) {
      setSelectedEntradaProduto(entradaProdutoLista.find(x => x.IdEntradaProduto === id));
      setEntradaModal(entradaModal);
    }
    else setEntradaModal(entradaModal);
  }, [entradaProdutoLista]);

  const handleCadastroEntradaMultiOpenState = useCallback((entradaModal: boolean) => {
    setProdutoIdSessaoLista([]);
    setSelectedProdutosServicosQuery(null);
    if (entradaModal) setEntradaMultiModal(entradaModal);
    else setEntradaMultiModal(entradaModal);
  }, []);


  const handleDeleteModalOpenState = useCallback((Id: number | null, openState: boolean) => {
    if (openState) {
      if (Id && entradaProdutoLista) {
        setSelectedEntradaProduto(entradaProdutoLista.find(x => x.IdEntradaProduto === Id));
      } else {
        setSelectedEntradaProduto(undefined);
      }
    }
    setDeleteModal(openState);
  }, [entradaProdutoLista]);

  const handleDeleteConfirma = useCallback(async () => {
    if (selectedEntradaProduto) {
      try {
        setSaving(true);
        await deleteEntradaPUseCase.deleteEntradaP(selectedEntradaProduto.IdEntradaProduto);
        await loadEstoqueListaState();
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao excluir produto!'));
      } finally {
        setSaving(false);
        setDeleteModal(false);
      }
    }
  }, [deleteEntradaPUseCase, loadEstoqueListaState, pushErrorNotification, selectedEntradaProduto]);

  const handleEntradaProdutoSubmit = useCallback(async (form: EntradaProdutoForm) => {
    try {
      if (selectedEntradaProduto) {
        await updateEntradaPUseCase.updateEntradaP(selectedEntradaProduto.IdEntradaProduto, form.Data ?? null, form.IdCentroCusto ?? null, form.IdProdutoServico ?? null, form.NroNotaFiscal ?? null, form.Quantidade ?? null, form.IdFornecedor ?? null, form.IdOrdemCompraProduto ?? null, form.NrNotaFiscal ?? null, form.IdSessaoMultipla ?? null, form.ValorUnitario ?? null);
        pushInfoNotification("Sucesso", "Produto atualizado com sucesso!", { isAutoFinish: true });
        setEntradaModal(false);
        await loadEstoqueListaState();

      } else {
        var id = await createEntradaPUseCase.createEntradaP(form.Data ?? null, null, form.IdCentroCusto ?? null, form.IdProdutoServico ?? null, form.NroNotaFiscal ?? null, form.Quantidade ?? null, form.IdFornecedor ?? null, form.IdOrdemCompraProduto ?? null, form.NrNotaFiscal ?? null, form.IdSessaoMultipla ?? null, form.ValorUnitario ?? null)
        pushInfoNotification("Sucesso", "Produto criado com sucesso!", { isAutoFinish: true });
        setIdEntradaProduto(id);
        setEntradaModal(false);
        await loadEstoqueListaState();
      }
    } catch (e) {
      pushErrorNotification("Erro", processError(e, 'Falha ao criar/atualizar Entrada Produtos!'));
    } finally {
      setSaving(false);
    }
  }, [createEntradaPUseCase, loadEstoqueListaState, pushErrorNotification, pushInfoNotification, selectedEntradaProduto, updateEntradaPUseCase]);

  const handleEntradaProdutoMultiSubmit = useCallback(async (form: EntradaProdutoForm) => {
    try {
      const selectedProdutoServicoIds = selectedProdutosServicosQuery?.map(x => x.idProdutoServico) ?? [];
      if (selectedProdutoServicoIds.length === 0) {
        throw new UserFriendlyError("Selecione pelo menos um produto para incluir.");
      }
      setSaving(true);
      const IdSessaoMultipla = await createEntradaMultiPUseCase.createEntradaMultiP(form.Data ?? null, form.IdCentroCusto ?? null, selectedProdutoServicoIds ?? null, form.NroNotaFiscal ?? null, form.Quantidade ?? null, form.IdFornecedor ?? null, form.IdOrdemCompraProduto ?? null, form.NrNotaFiscal ?? null, form.IdSessaoMultipla ?? null, form.ValorUnitario ?? null)

      const items = await loadEntradaProdutosSessao(getAllListagemEstoqueUseCase, IdSessaoMultipla);
      if (items.length === 0) {
        throw new UserFriendlyError("Os produtos foram gravados, mas não foram retornados na consulta da sessão. Atualize a lista para conferir as entradas antes de incluir novamente.");
      }
      setProdutoIdSessaoLista(previous => {
        const existingIds = new Set(previous.map(item => item.IdEntradaProduto));
        return [...previous, ...items.filter(item => !existingIds.has(item.IdEntradaProduto))];
      });
      setSelectedProdutosServicosQuery(null);
      pushInfoNotification("Sucesso", "Produtos incluídos com sucesso!", { isAutoFinish: true });

    } catch (e) {
      pushErrorNotification("Erro", processError(e, 'Falha ao criar/atualizar Produtos!'));
    } finally {
      setSaving(false);
    }
  }, [createEntradaMultiPUseCase, getAllListagemEstoqueUseCase, pushErrorNotification, pushInfoNotification, selectedProdutosServicosQuery]);

  const handleUpdateMutiTodos = async () => {
    try {
      setSaving(true);
      const payload = produtoIdSessaoLista;
      if (payload.length === 0) return pushWarnNotification("Atenção", "Nenhum produto selecionado para atualização!");
      await updateEntradaMultiPUseCase.updateEntradaMultiP(payload);

      pushInfoNotification("Sucesso", "Produtos atualizados com sucesso!", { isAutoFinish: true });
      await loadEstoqueListaState();

    } catch (e) {
      pushErrorNotification("Erro", "Falha ao atualizar os Produtos.");
    } finally {
      if (produtoIdSessaoLista.length > 0) {
        setSelectedProdutosServicosQuery(null);
        setProdutoIdSessaoLista([]);
        setEntradaMultiModal(false);
        setEntradaModal(false);
      }
      setSaving(false);
    }
  };

  const handleProdutosServicosQueryChange = useCallback((items: ProdutoServicoDropDown[] | null) => {
    setSelectedProdutosServicosQuery(items);
  }, []);

  const handleCentroCustoQueryChange = useCallback((items: CentroCustoDropDown[] | null) => {
    setSelectedCentroCustoQuery(items);
  }, []);

  const handleFornecedorQueryChange = useCallback((items: FornecedorDropDown[] | null) => {
    setSelectedFornecedorQuery(items);
  }, []);

  const handleCentroCustoChange = (novoIdCentroCusto: number | null, idLinhaGrid: GridRowId) => {
    setProdutoIdSessaoLista((listaAtual) =>
      listaAtual.map((item) =>
        item.IdEntradaProduto === idLinhaGrid
          ? { ...item, IdCentroCusto: novoIdCentroCusto }
          : item
      )
    );
  };
  const handleQuantidadeChange = (novaQtd: number | null, idLinhaGrid: GridRowId) => {
    setProdutoIdSessaoLista((listaAtual) =>
      listaAtual.map((item) =>
        item.IdEntradaProduto === idLinhaGrid
          ? { ...item, Quantidade: novaQtd }
          : item
      )
    );
  };
  const handleFornecedorMChange = (novoIdFornecedor: number | null, idLinhaGrid: GridRowId) => {
    setProdutoIdSessaoLista((listaAtual) =>
      listaAtual.map((item) =>
        item.IdEntradaProduto === idLinhaGrid
          ? { ...item, IdFornecedor: novoIdFornecedor }
          : item
      )
    );
  };

  // const handleValorChange = (novoValor: string | null, idLinhaGrid: GridRowId) => {
  //     setProdutoIdSessaoLista((listaAtual) => 
  //         listaAtual.map((item) => {

  //             const valorTratado = novoValor ? Number(novoValor.replace(',', '.')) : null;

  //             return item.IdEntradaProduto === idLinhaGrid 
  //                 ? { ...item, ValorUnitario: valorTratado } 
  //                 : item
  //         })
  //     );
  // };

  const handleValorChange = (novoValor: string | null, IdEntradaProduto: number) => {

    setProdutoIdSessaoLista((prevState) => {
      return prevState.map((item): EntradaProduto => {
        if (item.IdEntradaProduto === IdEntradaProduto) {
          return {
            ...item,
            ValorUnitario: novoValor !== null ? Number(novoValor) : null,
          };
        }
        return item;
      });
    });
  };

  //#endregion


  //#region Filtros
  const handleClearFilters = useCallback(async () => {
    try {
      setLoading(true);
      filters.clearFilters();
      pagination.setPage(1);
      await loadEstoqueListaState({ ...initialFiltersValues, page: 1 });
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, 'Falha ao buscar produtos!'));
    } finally {
      setLoading(false);
    }
  }, [filters, loadEstoqueListaState, pagination, pushErrorNotification]);

  const handlePesquisaChange = useDebouncedCallback(debouncedRef, (newValue: string | null) => {
    useEntradaProdutoFilters.getState().setPesquisa(newValue);

    if (newValue) {
      return async () => {
        try {
          setLoading(true);
          useEntradaProdutoPagination.getState().setPage(1);
          await loadEstoqueListaState({ pesquisa: newValue, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar produtos!"));
        } finally {
          setLoading(false);
        }
      }
    } else {
      return async () => {
        try {
          setLoading(true);
          useEntradaProdutoPagination.getState().setPage(1);
          await loadEstoqueListaState();
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar produtos!"));
        } finally {
          setLoading(false);
        }
      }
    }
  },
    [loadEstoqueListaState, pushErrorNotification, setLoading]
  );

  const handleOrdemCompraChange = useCallback(async (newValue: number[] | null) => {
    const ordemCompra = newValue ?? [];
    useEntradaProdutoFilters.getState().setFilters({ ordemCompra });

    try {
      setLoading(true);
      useEntradaProdutoPagination.getState().setPage(1);
      await loadEstoqueListaState({ ordemCompra, page: 1 });
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar produtos!"));
    } finally {
      setLoading(false);
    }
  }, [loadEstoqueListaState, pushErrorNotification]);

  const handleFornecedorChange = useDebouncedCallback(debouncedRef, async (newValue: number) => {
    useEntradaProdutoFilters.getState().setFornecedorPesquisa(newValue);

    try {
      setLoading(true);
      useEntradaProdutoPagination.getState().setPage(1);
      await loadEstoqueListaState({ FornecedorPesquisa: newValue, page: 1 } as any);
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar !"));
    } finally {
      setLoading(false);
    }

    return () => { };
  }, [pushErrorNotification, loadEstoqueListaState]);

  const handleProdutorChange = useDebouncedCallback(debouncedRef, async (newValue: number) => {
    useEntradaProdutoFilters.getState().setProdutoPesquisa(newValue);

    try {
      setLoading(true);
      useEntradaProdutoPagination.getState().setPage(1);
      await loadEstoqueListaState({ ProdutoPesquisa: newValue, page: 1 } as any);
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar !"));
    } finally {
      setLoading(false);
    }

    return () => { };
  }, [pushErrorNotification, loadEstoqueListaState]);

  const handleCentroDeCustoChange = useDebouncedCallback(debouncedRef, (newValue: number[]) => {
    useEntradaProdutoFilters.getState().setCentroDeCusto(newValue);
    return async () => {
      try {
        setLoading(true);
        useEntradaProdutoPagination.getState().setPage(1);
        await loadEstoqueListaState({ centroDeCusto: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar !"));
      } finally {
        setLoading(false);
      }
    }
  }, []);

  const handleDataReceberRangeChange = useDebouncedCallback(debouncedRef,
    (dataEntradaDe: Date | null, dataEntradaAte: Date | null) => {
      filters.setFilters({ dataEntradaDe });
      filters.setFilters({ dataEntradaAte });

      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadEstoqueListaState({ dataEntradaDe, dataEntradaAte, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Error", processError(e, "Falha ao buscar produtos!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters]
  );

  //#endregion


  //#region Relatorio
  const handleReportModalOpenState = useCallback((openState: boolean) => {
    setOpenReportModal(openState);
  }, []);

  const handleSubmitReport = useCallback(async (form: EntradaProdutoForm) => {
    try {
      setSaving(true);
      const selectedProdutoServicoIds = selectedReportProdutosServicosQuery?.map(x => x.idProdutoServico) ?? [];
      const selectedCentroCustods = selectedCentroCustoQuery?.map(x => x.id) ?? [];
      const selectedFornecedords = selectedFornecedorQuery?.map(x => x.idFornecedor) ?? [];
      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportEntradaProdutoUseCase.getReportEntradaProduto(
            requiredMimeType,
            idUsuario,
            selectedFornecedords,
            selectedProdutoServicoIds,
            form.NrNotaFiscal,
            selectedCentroCustods,
            form.Data,
            form.DataSaida,

          ),
        closeReportModalCallback: () => {
          setOpenReportModal(false);
        }
      });
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao gerar relatorio"));
    } finally {
      setSaving(false);
    }
  }, [
    idUsuario,
    getReportEntradaProdutoUseCase,
    selectedCentroCustoQuery,
    selectedFornecedorQuery,
    selectedReportProdutosServicosQuery,
    pushErrorNotification,
    startReportViewerProcess,
  ]);

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      }
    },
    [changeHistory],
  );

  const handleNewProdutoServico = useCallback(() => {
    startProdutoServicoDrawer(
      async (form) => {
        try {
          setSaving(true);
          setPageSaving(true);

          const idProdutoServico = await createServicoProdutoUseCase.createServicoProduto(
            form.ativo,
            form.produtoServico,
            form.tipo,
            form.unidade,
            form.norma,
          );

          await loadProdutoServicosDropDown(dt => {
            const createdProdutoServico = dt.find(x => x.idProdutoServico === idProdutoServico);
            if (createdProdutoServico) {
              setSelectedProdutosServicosQuery(prev => prev !== null
                ? ([...prev, { ...createdProdutoServico }])
                : null
              );
            }
            setProdutoServicoDropdown(dt);
          }, {
            incluirCodigoDescricao: true,
          });

          pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
        } catch (e: unknown) {
          pushErrorNotification('Erro', processError(e, 'Falha ao salvar requisição de produto/serviço!'));
        } finally {
          setSaving(false);
          setPageSaving(false);
        }
      },
    );
  }, [
    createServicoProdutoUseCase,
    startProdutoServicoDrawer,
    loadProdutoServicosDropDown,
    pushInfoNotification,
    pushErrorNotification,
    setPageSaving,
  ]);

  //#endregion

  const handleImportXmlModalOpenState = useCallback((openState: boolean) => {
    setImportXmlModal(openState);
  }, [
  ]);

  const handleImportXmlSubmit = useCallback(async (
    idFornecedor: number | null,
    idCentroCusto: number | null,
    dataCadastro: Date | null,
    dataEmissao: Date | null,
    notaFiscal: string | null,
    produtos: {
      idProdutoServico: number | null,
      produtoNota: string | null,
      quantidade: number,
      valorUnitario: number,
      valorTotal: number,
    }[],
  ) => {
    try {
      setSaving(true);
      setPageSaving(true);

      if (dataEmissao === null) {
        throw new UserFriendlyError('A data de emissão deve ser preenchido!');
      }

      produtos.forEach(p => {
        if (p.idProdutoServico === null) {
          throw new UserFriendlyError('Alguns produtos não foram relacionados, preencha a relação e/ou exclua-os para continuar!');
        }
      });

      produtos.forEach(async (p) => {
        await createEntradaPUseCase.createEntradaP(
          dataCadastro,
          dataEmissao,
          idCentroCusto,
          p.idProdutoServico,
          notaFiscal,
          p.quantidade,
          idFornecedor,
          null,
          notaFiscal,
          null,
          p.valorUnitario,
        );
      });

      pushInfoNotification('Sucesso', 'Produtos importados com sucesso!');
      await loadEstoqueListaState();
      setImportXmlModal(false);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao importar xml!'));
    } finally {
      setSaving(false);
      setPageSaving(false);
    }
  }, [
    createEntradaPUseCase,
    loadEstoqueListaState,
    pushErrorNotification,
    pushInfoNotification,
    setPageSaving,
  ]);

  const handleImportXmlNewProduct = useCallback((callback: (idProdutoServico: number) => void, produto: string) => {
    startProdutoServicoDrawer(
      async (form) => {
        try {
          setSaving(true);
          setPageSaving(true);

          const idProdutoServico = await createServicoProdutoUseCase.createServicoProduto(
            form.ativo,
            form.produtoServico,
            form.tipo,
            form.unidade,
            form.norma,
          );

          await loadProdutoServicosDropDown(dt => {
            const createdProdutoServico = dt.find(x => x.idProdutoServico === idProdutoServico);
            if (createdProdutoServico) callback(idProdutoServico);
            setProdutoServicoDropdown(dt);
          }, {
          });

          pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
        } catch (e: unknown) {
          pushErrorNotification('Erro', processError(e, 'Falha ao salvar requisição de produto/serviço!'));
        } finally {
          setSaving(false);
          setPageSaving(false);
        }
      }
    );
  }, [
    createServicoProdutoUseCase,
    startProdutoServicoDrawer,
    loadProdutoServicosDropDown,
    pushInfoNotification,
    pushErrorNotification,
    setPageSaving,
  ]);

  const handleImportXmlNewFornecedor = useCallback((callback: (idFornecedor: number) => void) => {
    startFornecedorDrawer(
      async (form) => {
        try {
          setSaving(true);
          setPageSaving(true);

          const qualificacoes = await getAllFornecedorQualificacaoUseCase
            .getAllFornecedorQualificacao(null);

          const defaultQualificacao = [{ idQualificacao: qualificacoes[0].idQualificacao, qualificado: true, observacao: '' }];

          const idFornecedor = await createFornecedorUseCase.createFornecedorSimplificado(
            form.ativo,
            form.avaliarFornecedor,
            form.fornecedorProdutos,
            form.fornecedorServicos,
            form.nomeFantasia,
            form.razaoSocial,
            form.centroCusto,
            form.cnpj,
            form.cpf,
            form.observacoes,
            defaultQualificacao,
          );

          const results = await getFornecedorDropDownUseCase.getFornecedorDropDown();
          const createdProdutoServico = results.find(x => x.idFornecedor === idFornecedor);
          if (createdProdutoServico) callback(idFornecedor);
          setFornecedorLista(results);

          pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
        } catch (e: unknown) {
          pushErrorNotification('Erro', processError(e, 'Falha ao salvar requisição de produto/serviço!'));
        } finally {
          setSaving(false);
          setPageSaving(false);
        }
      }
    );
  }, [
    createFornecedorUseCase,
    getFornecedorDropDownUseCase,
    getAllFornecedorQualificacaoUseCase,
    startFornecedorDrawer,
    pushInfoNotification,
    pushErrorNotification,
    setPageSaving,
  ]);

  return {
    loading,
    saving,
    errorMessage,
    entradaProdutoLista,
    selectedEntradaProduto,
    reportViewerState,
    produtoServicoDrawerState,
    fornecedorDrawerState,
    pagination,
    filters,
    entradaModal,
    changeHistory,
    centroDeCustoLista,
    hookForm,
    deleteModal,
    selectedProdutosServicosQuery,
    selectedReportProdutosServicosQuery,
    handleReportProdutosServicosQueryChange: setSelectedReportProdutosServicosQuery,
    entradaMultiModal,
    importXmlModal,
    listaItens,
    fornecedorLista,
    ordemComprasDropdown,
    produtoIdSessaoLista,
    openReportModal,
    selectedCentroCustoQuery,
    selectedFornecedorQuery,
    produtoServicoDropdown: produtoServicoDropdown ?? [],
    handleFornecedorQueryChange,
    handleCentroCustoQueryChange,
    handleReportModalOpenState,
    handleUpdateMutiTodos,
    handleCentroCustoChange,
    handleValorChange,
    handleFornecedorMChange,
    handleQuantidadeChange,
    handleEntradaProdutoMultiSubmit,
    setEntradaMultiModal,
    handleCadastroEntradaMultiOpenState,
    setEntradaModal,
    handleEntradaProdutoSubmit,
    handleReload,
    handleRowsPerPageChange,
    handlePageChange,
    handleCadastroEntradaOpenState,
    handleDeleteConfirma,
    handleDeleteModalOpenState,
    handleClearFilters,
    handleSubmitReport,
    handleFornecedorChange,
    handleCentroDeCustoChange,
    handleDataReceberRangeChange,
    handlePesquisaChange,
    handleOrdemCompraChange,
    handleProdutorChange,
    handleOpenChangeHistory,
    handleProdutosServicosQueryChange,
    handleNewProdutoServico,
    handleImportXmlModalOpenState,
    handleImportXmlSubmit,
    handleImportXmlNewProduct,
    handleImportXmlNewFornecedor,
  }
}
